import { InjectionToken } from '@angular/core';

export const IMPORT_DATA_PROCESSOR_WORKER_FACTORY_PROVIDER_TOKEN = new InjectionToken<() => Worker>(
  'IMPORT_DATA_PROCESSOR_WORKER_FACTORY_PROVIDER_TOKEN',
);
